import { databases } from "@/lib/appwrite";

export const createSessionNote = async (
  userId: string,
  sessionId: string,
  noteContent: string
) => {
  const createdAt = new Date().toISOString();

  const response = await databases.createDocument(
    import.meta.env.VITE_APPWRITE_DATABASE_ID,
    import.meta.env.VITE_WORK_SESSION_NOTES_COLLECTION_ID,
    "unique()",
    {
      userId,
      sessionId,
      noteContent,
      isRead: false,
      createdAt,
      updatedAt: null
    }
  );

  return response;
};


